module.exports = __webpack_public_path__ + "static/Fred_Meyer_pin_hover-3389b3dd32e72dca345d0f4cdc54eeba.png";